export const ROUTE_PATH = '/efs-sales';
